module.exports = __webpack_public_path__ + "static/media/grad-split.268310ab.png";